// Phone width (below `md`, 768px): the Tasks page swaps its wide table for a
// card list. Read through matchMedia so only one of the two is mounted.
import { useSyncExternalStore } from 'react'

const MOBILE_QUERY = '(max-width: 767px)'

function subscribe(onChange: () => void) {
  if (typeof window === 'undefined' || !window.matchMedia) return () => undefined
  const media = window.matchMedia(MOBILE_QUERY)
  media.addEventListener('change', onChange)
  return () => media.removeEventListener('change', onChange)
}

function snapshot() {
  if (typeof window === 'undefined' || !window.matchMedia) return false
  return window.matchMedia(MOBILE_QUERY).matches
}

export function useMobileViewport(): boolean {
  return useSyncExternalStore(subscribe, snapshot, () => false)
}
